var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('AsiPageTitle',{attrs:{"title":_vm.$t('order.plural'),"icon":_vm.icons.orders}}),_c('OrderList',{attrs:{"memory-key":"admin-customer-orders"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }